import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';

import FormSelect from '../../../components/form/FormSelect';

import { processAllOptionGet } from '../../../store/slices/tenantSlices/dailyReportSlice';
import { breakCopy } from '../../../store/slices/tenantSlices/settingSlice';

const CopyBreakModal = ({ isOpen, onCloseClick }) => {
  const dispatch = useDispatch();
  const [processOptions, setProcessOptions] = useState([]);

  const initialValues = {
    target_process_id: '',
    source_process_id: ''
  };

  const validationSchema = Yup.object({
    source_process_id: Yup.string()
      .required('Source Process is required')
      .notOneOf([Yup.ref('target_process_id')], 'Source and Target cannot be the same'),
    target_process_id: Yup.string()
      .required('Target Process is required')
      .notOneOf([Yup.ref('source_process_id')], 'Target and Source cannot be the same')
  });

  const onSubmit = async () => {
    try {
      const payload = { ...values };
      const response = await dispatch(breakCopy(payload)).unwrap();
      if (response && response?.success) {
        toast.success(response?.message || 'Breaks copied successfully');
        onCloseClick(true);
        resetForm();
      } else {
        toast.error(response?.message || 'Error copying breaks');
      }
    } catch (error) {
      console.log('error', error);
      toast.error('Something went wrong');
    }
  };

  const { values, handleChange, handleBlur, handleSubmit, touched, errors, resetForm } = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  });

  const getProcessOption = async () => {
    try {
      const response = await dispatch(processAllOptionGet()).unwrap();
      if (response && response.data) {
        const options = response.data.map((val) => ({
          label: val.name,
          value: val.id
        }));
        setProcessOptions(options);
      } else {
        setProcessOptions([]);
      }
    } catch (error) {
      setProcessOptions([]);
      console.log('error', error);
    }
  };

  useEffect(() => {
    getProcessOption();
  }, []);

  return (
    <Modal isOpen={isOpen} size="lg" centered>
      <ModalHeader className="justify-content-center py-2">
        <div className="fs-5">{'Copy Break'}</div>
      </ModalHeader>
      <ModalBody className="px-4">
        <form id="copy-breaks" onSubmit={handleSubmit}>
          <Row>
            <Col lg="4">
              <FormSelect
                name="source_process_id"
                label="Source Process"
                placeholder="Select Source Process"
                value={values.source_process_id}
                options={processOptions}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched}
                errors={errors}
                menuPlacement="bottom"
              />
            </Col>
            <Col lg="4">
              <FormSelect
                name="target_process_id"
                label="Target Process"
                placeholder="Select Target Process"
                value={values.target_process_id}
                options={processOptions}
                onChange={handleChange}
                onBlur={handleBlur}
                touched={touched}
                errors={errors}
                menuPlacement="bottom"
              />
            </Col>
          </Row>
        </form>
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => {
            onCloseClick();
            resetForm();
          }}
          className="px-5 bg-transparent text-primary">
          Cancel
        </Button>
        <Button form="copy-breaks" type="submit" className="px-5 bg-primary border-primary">
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

CopyBreakModal.propTypes = {
  isOpen: PropTypes.bool,
  onCloseClick: PropTypes.func
};

export default CopyBreakModal;
